import { containsPIIData } from '../containsPIIData';
import { isEmptyValue } from './isEmptyValue';
/**
 * Checks for PII data. If PII data is found the function will throw an error, otherwise it returns a stripped version of the input.
 * Normally will be done outside of this function (SOLID principles) however, as the operation may be intense,
 * it is better to leave inside for the sake of performance.
 */
export function checkPIIAndFormatValues(data) {
    return JSON.parse(JSON.stringify(data, (key, value) => {
        // Only start checking when strings are given.
        if (isEmptyValue(value))
            return undefined;
        if (typeof value !== 'string') {
            return value;
        }
        // Should break tracking when PII data is being sent. Fines can be given otherwise.
        if (containsPIIData(value)) {
            throw new Error('Cannot send PII data.');
        }
        /**
         * Coerce to lower case; except when "currency" property.
         * This value has to be in captitals according to Google's GA4 documentation.
         */
        if (key === 'currency') {
            return value.toUpperCase();
        }
        return value.toLowerCase();
    }));
}
